import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { element } from 'protractor';
import { SideBar } from 'src/app/interface/sidebar';
import { PermisosLogin } from 'src/app/models/login/permisos-login';
import { rolAccion } from 'src/app/models/login/rolAccion';
import { EstadoServices } from 'src/app/services/candidato/estado.services';
import { LoginService } from 'src/app/services/login/login.services';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Output() valorSalida: EventEmitter<boolean> = new EventEmitter();
  permisos: PermisosLogin[] = [];
  rol: rolAccion = {
    idUsuPersona: '',
    carUsuPersona: 0
  }
  c1 = 1;
  c2 = 2;
  c3 = 3;
  c4 = 4;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  opciones: SideBar[] = [
    {
      idSegAccion: 0,
      icono: 'fas fa-home',
      nombre: 'Inicio',
      path: '/dashboard/inicio',
      permiso: null
    },
    {
      idSegAccion: 1,
      icono: 'fas fa-user-friends',
      nombre: 'Usuarios',
      path: '/usuarios',
      permiso: null,
      opciones: [
        {
          idSegAccion: 22,
          icono: 'fas fa-window-minimize',
          nombre: 'Vincular Usuarios',
          path: '/vincular',
          permiso: true
        },
        {
          idSegAccion: 23,
          icono: 'fas fa-window-minimize',
          nombre: 'Personas Naturales',
          path: '/personas',
          permiso: true
        },
        {
          idSegAccion: 25,
          icono: 'fas fa-window-minimize',
          nombre: 'Gestion de usuarios',
          path: '/personas',
          permiso: true
        },
        {
          idSegAccion: 26,
          icono: 'fas fa-window-minimize',
          nombre: 'Banco de diseñadores y validadores',
          path: '/personas',
          permiso: true
        },
      ]
    },
    {
      idSegAccion: 34,
      icono: 'fas fa-cog',
      nombre: 'Banner',
      path: 'banner',
      permiso: null
    },
    {
      idSegAccion: 2,
      icono: 'fas fa-paste',
      nombre: 'Noticias',
      path: 'homeAdmin',
      permiso: null,
      opciones: [
        {
          idSegAccion: 27,
          icono: 'fas fa-window-minimize',
          nombre: 'Ver noticias',
          path: '/personas',
          permiso: true
        },
        {
          idSegAccion: 28,
          icono: 'fas fa-window-minimize',
          nombre: 'Gestion de noticias',
          path: '/personas',
          permiso: true
        },
      ]
    },
    {
      idSegAccion: 3,
      icono: 'fas fa-folder',
      nombre: 'Repositorio de ítems',
      path: 'repositorioItems',
      permiso: null
    },
    {
      idSegAccion: 4,
      icono: 'fas fa-list-alt',
      nombre: 'Banco de ítems',
      path: 'bancoItems',
      permiso: null
    },
    {
      idSegAccion: 5,
      icono: 'fas fa-cog',
      nombre: 'Parámetros funcionales',
      path: '',
      permiso: null,
      opciones: [
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Área de conocimiento',
          path: 'areaConocimiento',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Componente',
          path: 'componente',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Conocimiento a medir',
          path: 'conocimientoMedir',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Grado',
          path: 'grado',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Competencia',
          path: 'competencia',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Habilidad a medir',
          path: 'habilidadMedir',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Grupo objetivo',
          path: 'grupoObjetivo',
          permiso: true
        }
      ]
    },
    {
      idSegAccion: 5,
      icono: 'fas fa-cog',
      nombre: 'Configuración',
      path: '',
      permiso: null,
      opciones: [
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Grupo objetivo',
          path: 'definirGrupoObjetivo',
          permiso: true
        },
        {
          icono: 'fas fa-window-minimize',
          nombre: 'Catálogo de programas',
          path: 'catalogoProgramas',
          permiso: true
        }
      ]
    },
    {
      idSegAccion: 12,
      icono: 'fas fa-paste',
      nombre: 'Configuración tipo de prueba',

      path: 'RepositorioTipoPrueba',
      permiso: null

    },
    {
      idSegAccion: 13,
      icono: 'fas fa-stopwatch',
      nombre: 'Vigencia',
      path: 'repositorioVigencia',
      permiso: null
    },

    {
      idSegAccion: 14,
      icono: 'fas fa-sliders-h',
      nombre: 'Tablero de control',
      path: 'homeAdmin',
      permiso: null
    },
    {
      idSegAccion: 15,
      icono: 'fas fa-chart-bar',
      nombre: 'Análisis de resultados',
      path: 'analisisResultado',
      permiso: null
    },
    {
      idSegAccion: 16,
      icono: 'fas fa-copy',
      nombre: 'Reportes',
      path: '',
      permiso: null,
      opciones: [
        {
          idSegAccion: 30,
          icono: 'far fa-window-minimize',
          nombre: 'Reportes fijos',
          path: 'reporte-programas',
          permiso: true
        },
        {
          idSegAccion: 31,
          icono: 'far fa-window-minimize',
          nombre: 'Reportes dinámicos',
          path: '/personas',
          permiso: true
        },
      ]
    },
    {

      icono: 'fas fa-home',
      nombre: 'Inicio',
      path: 'inicioCandidato',
      permiso: null
    },
    {
      idSegAccion: 17,
      icono: 'fas fa-clipboard-list',
      nombre: 'Presentar prueba',
      path: 'pruebasOnline',
      permiso: null,
      opciones: [
        //{
        //  idSegAccion: 32,
        //  icono:'fas fa-window-minimize',
        //  nombre:'Prueba online controlada (Deshabilitado)',
        //  path: '/pers',
        //  permiso: true
        //},
        {
          idSegAccion: 33,
          icono: 'fas fa-window-minimize',
          nombre: 'Prueba online',
          path: 'pruebasOnline',
          permiso: true
        }
      ]
    },
    {
      idSegAccion: 20,
      icono: 'fab fa-wpforms',
      nombre: 'Ver resultados',
      path: 'verResultados',
      permiso: null
    }
    //,
    //{
    //  idSegAccion:21,
    //  icono:'fas fa-envelope',
    //  nombre:'Buzón de sugerencias (Deshabilitado)',
    //  path: 'homeAdmin',
    //  permiso: null
    //},
    //{
    //  idSegAccion:29,
    //  icono:'fas fa-envelope',
    //  nombre:'Buzón de sugerencias (Deshabilitado)',
    //  path: 'sugerencias',
    //  permiso: null
    //}
  ]
  usuario: string;
  buscarId(id: any) {
    let centinela = this.opciones.find(element => element.idSegAccion == id);
    if (centinela) {
      let cont = this.opciones.findIndex(element => element == centinela)

      this.opciones[cont].permiso = true;
    }


  }
  colapsar() {
    document.getElementById('menu-items').className = "collapse";
    this.estado();
  }
  estado() {
    let estadoCollapse = localStorage.getItem('estadoCollapse');
    console.log(estadoCollapse)
    if (estadoCollapse == '1') {
      this.valorSalida.emit(true);
      localStorage.setItem('estadoCollapse', '0');
    } else {
      this.valorSalida.emit(false);
      localStorage.setItem('estadoCollapse', '1');
    }

  }

  collapseButton(i) {

    if (i.opciones) {
      return
    } else {
      document.getElementById("idFocus").focus();

    }
  }

  focusSubmenu() {
    console.log('entro')
    document.getElementById("idFocus").focus();
    // this.myInputField.nativeElement.focus();
  }

  constructor(
    private loginSevices: LoginService
  ) {
    this.usuario = (localStorage.getItem('us'));
    console.log(this.usuario);
    let id = localStorage.getItem('xzs');
    console.log(id);
    if (this.usuario == 'admin') {
      this.rol.idUsuPersona = id;
      this.rol.carUsuPersona = 1;
      console.log(this.rol);
      // this.loginSevices.getPermisos(this.rol).subscribe(data =>{

      //   this.permisos = data.segAccionesXRolList;

      //   console.log(data);
      //   for(let i = 0; i< this.permisos.length; i++){

      //     if(this.permisos[i].idSegAccion >= 6 && this.permisos[i].idSegAccion <= 11){


      //     }else {
      //       this.buscarId(this.permisos[i].idSegAccion)
      //     }
      //   }

      // })
      this.opciones.map(element => {
        if (element.idSegAccion >= 1 && element.idSegAccion <= 16) {
          element.permiso = true;
        }
        if (element.idSegAccion == 21) {
          element.permiso = true;
        }
        if (element.idSegAccion == 34) {
          element.permiso = true;
        }
      })
      this.opciones[0].permiso = true;


    }
    if (this.usuario === 'cand') {
      console.log(id);
      this.rol.idUsuPersona = id;
      this.rol.carUsuPersona = 2;
      console.log(this.rol);
      // this.loginSevices.getPermisos(this.rol).subscribe(data =>{
      //  console.log(data);
      //   this.permisos = data.segAccionesXRolList;
      //   for(let i = 0; i< this.permisos.length; i++){

      //     if(this.permisos[i].idSegAccion >= 6 && this.permisos[i].idSegAccion <= 11){


      //     }else {
      //       this.buscarId(this.permisos[i].idSegAccion)
      //     }
      //   }
      // })

      this.opciones.map(element => {
        if (element.idSegAccion == 17) {
          element.permiso = true;
        }
        if (element.idSegAccion == 20) {
          element.permiso = true;
        }
        if (element.idSegAccion == 21) {
          element.permiso = true;
        }
      })
      this.opciones[0].permiso = true;

    }
  }
  ngOnInit(): void {

  }
}
